import { Link } from 'react-router-dom';
import { Box, Button, Chip, Paper, Typography, alpha } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { Code } from '../../../../helperComponents/showPrimitives';
import { StatusChip } from './StatusChip';
import { INGEST_RUN_STATUS_COLORS } from '../../../../../helpers/adsIngestRunsConstants';

const STATUS_ICONS = { ok: <CheckIcon />, error: <CloseIcon /> };

export const RunShowHeader = ({ record }) => {
  const color = INGEST_RUN_STATUS_COLORS[record.display_status] || 'default';
  const softSx = color === 'default'
    ? { bgcolor: 'grey.100', borderColor: 'transparent' }
    : { bgcolor: (theme) => alpha(theme.palette[color].main, 0.12), borderColor: 'transparent' };
  const jobRunsFilter = encodeURIComponent(JSON.stringify({
    job_name: record.job_name,
    internal_account_id: record.internal_account_id
  }));

  return (
    <Paper variant="outlined" sx={{ borderRadius: 3, p: 3, mb: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
          <Typography variant="h4" fontWeight={700}>{record.job_name}</Typography>
          <Chip size="small" label={record.job_type} sx={{ bgcolor: 'grey.100' }} />
          <StatusChip
            status={record.display_status}
            icon={STATUS_ICONS[record.display_status]}
            variant="outlined"
            sx={softSx}
          />
        </Box>
        <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
          <Button
            variant="outlined"
            color="inherit"
            startIcon={<WorkOutlineIcon />}
            component={Link}
            to={`/ads_jobs/${record.job_id}/show`}
            sx={{ borderColor: 'divider', textTransform: 'none' }}
          >
            Job
          </Button>
          <Button
            variant="outlined"
            color="inherit"
            startIcon={<FormatListBulletedIcon />}
            component={Link}
            to={`/ads_ingest_runs?filter=${jobRunsFilter}`}
            sx={{ borderColor: 'divider', textTransform: 'none' }}
          >
            Runs of this job
          </Button>
        </Box>
      </Box>
      <Typography color="text.secondary" sx={{ mt: 1 }}>
        Run {record.id} · account {record.account_name} (<Code>{record.customer_id}</Code>) · bridge {record.bridge_id} · script run <Code>{record.script_run_id}</Code>
      </Typography>
    </Paper>
  );
};
